import apiClient from './api';

export const billingService = {
  // Get user credits
  async getUserCredits() {
    const response = await apiClient.get('/billing/credits');
    return response.data;
  },

  // Get Stripe public key
  async getStripePublicKey() {
    const response = await apiClient.get('/billing/stripe-key');
    return response.data;
  },

  // Create payment intent
  async createPaymentIntent(credits) {
    const response = await apiClient.post('/billing/create-payment-intent', {
      credits: parseInt(credits),
    });
    return response.data;
  },

  // Create checkout session for hosted checkout
  async createCheckoutSession(data) {
    const response = await apiClient.post('/billing/create-checkout-session', {
      credits: parseInt(data.credits),
      amount: data.amount,
      promoCode: data.promoCode,
      discountInfo: data.discountInfo,
    });
    return response.data;
  },

  // Confirm payment
  async confirmPayment(paymentIntentId) {
    const response = await apiClient.post('/billing/confirm-payment', {
      payment_intent_id: paymentIntentId,
    });
    return response.data;
  },

  // Get transaction history
  async getTransactionHistory(page = 1, limit = 20) {
    const response = await apiClient.get('/billing/transactions', {
      params: { page, limit },
    });
    return response.data;
  },

  // Validate promo code
  async validatePromoCode(code, amount) {
    const response = await apiClient.post('/billing/validate-promo-code', {
      code,
      amount,
    });
    return response.data;
  },

  // Promo code management APIs
  // Get all promo codes
  async getAllPromoCodes() {
    const response = await apiClient.get('/billing/promo-codes');
    return response.data;
  },

  // Get promo code by ID
  async getPromoCodeById(id) {
    const response = await apiClient.get(`/billing/promo-codes/${id}`);
    return response.data;
  },

  // Create promo code
  async createPromoCode(promoData) {
    const response = await apiClient.post('/billing/promo-codes', promoData);
    return response.data;
  },

  // Update promo code
  async updatePromoCode(id, promoData) {
    const response = await apiClient.put(`/billing/promo-codes/${id}`, promoData);
    return response.data;
  },

  // Delete promo code
  async deletePromoCode(id) {
    const response = await apiClient.delete(`/billing/promo-codes/${id}`);
    return response.data;
  },

  // Get credit packages
  async getCreditPackages() {
    const response = await apiClient.get('/billing/price-packages');
    return response.data;
  },

  // Get subscription configuration (publishable key, price IDs)
  async getSubscriptionConfig() {
    const response = await apiClient.get('/billing/subscription/config');
    return response.data;
  },

  // Create subscription checkout session
  async createSubscriptionCheckoutSession(data) {
    const response = await apiClient.post('/billing/subscription/create-checkout-session', {
      priceId: data.priceId,
    });
    return response.data;
  },

  // Get checkout session details
  async getCheckoutSession(sessionId) {
    const response = await apiClient.get('/billing/subscription/checkout-session', {
      params: { sessionId },
    });
    return response.data;
  },

  // Create customer portal session
  async createCustomerPortalSession() {
    const response = await apiClient.post('/billing/subscription/customer-portal');
    return response.data;
  },

  // Get user's subscription status
  async getSubscriptionStatus({ includePaymentMethod = false } = {}) {
    const params = includePaymentMethod ? { includePaymentMethod: 'true' } : {};
    const response = await apiClient.get('/billing/subscription/status', { params });
    return response.data;
  },

  // Cancel subscription (at period end)
  async cancelSubscription() {
    const response = await apiClient.post('/billing/subscription/cancel');
    return response.data;
  },

  // Reactivate subscription
  async reactivateSubscription() {
    const response = await apiClient.post('/billing/subscription/reactivate');
    return response.data;
  },
}; 